export default "<a href=\"\" data-ng-click=\"to.onClick()\">{{ to.label }}</a>\n";